import {Injectable} from "@angular/core";
import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from "@angular/common/http";
import {Observable} from "rxjs";
import {environment} from "@sharedEnvironment/environment";

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  token: any = "";

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (-1 === req.url.search(environment.backAPI)) {
      return next.handle(req);
    }

    this.token = req.headers.get('Authorization');
    let tokenizada = req.headers.get('Tokenizada');
    const userDataString = localStorage.getItem('RBB-userData');
    if (userDataString && tokenizada !== "si") {
      const currentUser = JSON.parse(userDataString);
      this.token = `Bearer ${currentUser.token}`;
    }

    const secureRequest = req.clone({
      setHeaders: {
        'Authorization': this.token || `Bearer ${environment.tokenAPI}`
      }
    });

    return next.handle(secureRequest);
  }
}
